var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:( _obj = {
		'icon row d-flex align-items-center': true
	}, _obj[!_vm.$attrs.size ? 'large' : _vm.$attrs.size] = true, _obj ),attrs:{"to":_vm.$attrs.url}},[_c('div',{class:{
			'col-3': !_vm.$attrs.size ? true : false,
			'col-2': _vm.$attrs.size === 'small' ? true : false,
		}},[_c('span',{class:( _obj$1 = { 'bttn-icon': true }, _obj$1[_vm.$attrs.icon] = true, _obj$1 ),style:({ 'font-size': !_vm.$attrs['font-size'] ? '' : _vm.$attrs['font-size'] })})]),_c('div',{class:{ title: true, 'col-9': !_vm.$attrs.size ? true : false },domProps:{"innerHTML":_vm._s(_vm.$attrs.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }